import React, { useEffect, useState } from "react";

export default function Iqac() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div
      style={{
        position: "relative",
        top: windowWidth > 768 ? "125px" : "0px",
        marginBottom: "10vh",
        marginTop: "10vh",
        padding: windowWidth > 768 ? "80px" : "20px",
        height: "fit-content",
      }}
    >
      <h1 style={{ textAlign: "center", marginBottom: "40px" }}>
        Internal Quality Assurance Cell (IQAC)
      </h1>

      {/* Best Practices Section */}
      <section style={{ marginBottom: "40px" }}>
        <h2>Best Practices</h2>
        <div
          style={{
            backgroundColor: "#f8f9fa",
            padding: "20px",
            borderRadius: "8px",
          }}
        >
          <h3>Curriculum Design and Development</h3>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li style={{ marginBottom: "10px" }}>
              <strong>Industry-Relevant Curriculum:</strong> Regularly update
              the curriculum to keep up with industry trends, emerging
              technologies, and global standards. Include practical sessions,
              internships, and soft skills training.
            </li>
            <li style={{ marginBottom: "10px" }}>
              <strong>Choice-Based Credit System (CBCS):</strong> Implementing
              flexible course structures, allowing students to choose electives
              based on their interests and career goals.
            </li>
            <li style={{ marginBottom: "10px" }}>
              <strong>Interdisciplinary Programs:</strong> Encourage students to
              explore interdisciplinary learning to broaden their skills and
              knowledge base.
            </li>
          </ul>

          <h3>Teaching and Learning Processes</h3>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li style={{ marginBottom: "10px" }}>
              <strong>Active Learning Techniques:</strong> Incorporate flipped
              classrooms, case-based learning, group discussions, and
              project-based learning to engage students actively.
            </li>
            <li style={{ marginBottom: "10px" }}>
              <strong>Use of Technology in Teaching:</strong> Leverage digital
              platforms, smart boards, and e-resources to facilitate learning.
            </li>
            <li style={{ marginBottom: "10px" }}>
              <strong>Regular Faculty Development Programs (FDP):</strong>{" "}
              Conduct workshops, seminars, and training sessions to help faculty
              stay updated with the latest teaching methodologies and
              technologies.
            </li>
          </ul>

          <h3>Student Support and Progression</h3>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li style={{ marginBottom: "10px" }}>
              <strong>Mentoring and Counseling:</strong> Provide personal and
              academic counseling through a structured mentoring system. This
              helps address student concerns and improves retention rates.
            </li>
            <li style={{ marginBottom: "10px" }}>
              <strong>Career Guidance and Placement:</strong> Strengthen
              industry connections and collaborate with placement agencies to
              ensure high placement rates. Offer career development workshops
              and mock interviews.
            </li>
            <li style={{ marginBottom: "10px" }}>
              <strong>Student Skill Development Programs:</strong> Organize
              workshops on soft skills, leadership, communication, and
              entrepreneurship to make students industry-ready.
            </li>
          </ul>

          <h3>Infrastructure and Learning Resources</h3>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li style={{ marginBottom: "10px" }}>
              <strong>State-of-the-Art Facilities:</strong> Ensure that
              classrooms, laboratories, libraries, and other learning resources
              are well-equipped and regularly upgraded.
            </li>
            <li style={{ marginBottom: "10px" }}>
              <strong>Online and Offline Resources:</strong> Maintain a good
              collection of books, journals, and online databases. Offer digital
              access to academic resources like e-books, journals, and research
              papers.
            </li>
            <li style={{ marginBottom: "10px" }}>
              <strong>Smart Classrooms and Wi-Fi:</strong> Make use of modern
              tools like projectors, whiteboards, and interactive technologies
              to improve teaching and learning. Provide high-speed internet
              access across the campus.
            </li>
          </ul>

          <h3>Governance, Leadership, and Administration</h3>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li style={{ marginBottom: "10px" }}>
              <strong>Transparent and Effective Governance:</strong> Ensure
              clear policies and procedures for academic and administrative
              activities. Promote transparency in decision-making and
              communication.
            </li>
            <li style={{ marginBottom: "10px" }}>
              <strong>Academic and Administrative Audit:</strong> Regularly
              conduct internal and external audits to assess the performance of
              the institution and identify areas for improvement.
            </li>
            <li style={{ marginBottom: "10px" }}>
              <strong>Student Feedback Mechanism:</strong> Implement regular
              surveys to gather student feedback on faculty performance,
              infrastructure, and overall satisfaction, ensuring that changes
              are made based on the feedback.
            </li>
          </ul>

          <h3>Outcome-Based Education (OBE)</h3>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li style={{ marginBottom: "10px" }}>
              <strong>Defining Clear Learning Outcomes:</strong> Clearly
              articulate the program outcomes, course outcomes, and how they
              contribute to student development.
            </li>
            <li style={{ marginBottom: "10px" }}>
              <strong>Continuous Assessment:</strong> Implement continuous
              evaluation mechanisms like assignments, quizzes, projects, and
              exams to assess the progress of students.
            </li>
            <li style={{ marginBottom: "10px" }}>
              <strong>Academic Flexibility:</strong> Offer flexibility in the
              academic schedule, making it easier for students to balance
              academics with co-curricular activities and internships.
            </li>
          </ul>

          <h3>Community Engagement and Social Responsibility</h3>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li style={{ marginBottom: "10px" }}>
              <strong>Industry and Community Collaboration:</strong> Conduct
              outreach programs like internships, industrial visits, and
              community service initiatives to engage students in real-world
              problem-solving.
            </li>
            <li style={{ marginBottom: "10px" }}>
              <strong>Environmental Sustainability:</strong> Encourage green
              initiatives, such as rainwater harvesting, waste management, and
              promoting energy conservation on campus.
            </li>
            <li style={{ marginBottom: "10px" }}>
              <strong>Social Responsibility Initiatives:</strong> Organize
              activities like blood donation camps, health drives, and awareness
              campaigns to enhance students' social responsibility.
            </li>
          </ul>

          <h3>Research and Innovation</h3>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li style={{ marginBottom: "10px" }}>
              <strong>Encourage Research Activities:</strong> Establish research
              centers and labs. Encourage faculty and students to engage in
              research activities and publish papers in reputed journals.
            </li>
            <li style={{ marginBottom: "10px" }}>
              <strong>
                Collaborations with Industry and Research Institutions:
              </strong>{" "}
              Foster partnerships with industries, R&D organizations, and
              universities to conduct joint research projects.
            </li>
            <li style={{ marginBottom: "10px" }}>
              <strong>Research Funding and Grants:</strong> Facilitate faculty
              and students in applying for research grants and encourage
              innovation through startup incubation centers.
            </li>
          </ul>

          <h3>Continuous Improvement and Accreditation</h3>
          <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
            <li style={{ marginBottom: "10px" }}>
              <strong>Feedback and Quality Assurance Mechanisms:</strong>{" "}
              Regularly review and improve teaching processes based on feedback
              from students, faculty, and industry stakeholders.
            </li>
            <li style={{ marginBottom: "10px" }}>
              <strong>Self-Assessment Reports:</strong> Prepare and update
              comprehensive self-assessment reports that detail the
              institution’s strengths, weaknesses, and strategic goals.
            </li>
            <li style={{ marginBottom: "10px" }}>
              <strong>Internal Quality Assurance Cell (IQAC):</strong> Establish
              a dedicated body for monitoring quality in academic and
              administrative activities.
            </li>
            <li style={{ marginBottom: "10px" }}>
              <strong>Academic and Administrative Audit:</strong> Established a
              dedicated body for the Academic and Administrative Audit.
            </li>
          </ul>
        </div>
      </section>

      {/* IQAC Committee Section */}
      <section style={{ marginBottom: "40px" }}>
        <h2>IQAC Committee Composition</h2>
        <p>
          As per <strong>JSSUNI/REG/CIRCULAR/2024/010</strong> dated 19/08/2024
        </p>
        <div style={{ overflowX: "auto" }}>
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              marginTop: "20px",
            }}
          >
            <thead>
              <tr style={{ backgroundColor: "#343a40", color: "white" }}>
                <th style={{ padding: "12px", textAlign: "left" }}>Sl.No.</th>
                <th style={{ padding: "12px", textAlign: "left" }}>
                  Name & Designation
                </th>
                <th style={{ padding: "12px", textAlign: "left" }}>Role</th>
                <th style={{ padding: "12px", textAlign: "left" }}>Category</th>
              </tr>
            </thead>
            <tbody>
              <tr style={{ borderBottom: "1px solid #ddd" }}>
                <td style={{ padding: "12px" }}>1</td>
                <td style={{ padding: "12px" }}>Dr. H.R. Mahadevaswamy</td>
                <td style={{ padding: "12px" }}>Chairman</td>
                <td style={{ padding: "12px" }}>Vice-Chancellor</td>
              </tr>
              <tr style={{ borderBottom: "1px solid #ddd" }}>
                <td style={{ padding: "12px" }}>2</td>
                <td style={{ padding: "12px" }}>Dr. Mamatha TG</td>
                <td style={{ padding: "12px" }}>Member</td>
                <td style={{ padding: "12px" }}>Registrar</td>
              </tr>
              <tr style={{ borderBottom: "1px solid #ddd" }}>
                <td style={{ padding: "12px" }}>3</td>
                <td style={{ padding: "12px" }}>
                  Cmde. B.K. Gupta, Special Officer
                </td>
                <td style={{ padding: "12px" }}>Member</td>
                <td style={{ padding: "12px" }}>Senior Special Officer</td>
              </tr>
              <tr style={{ borderBottom: "1px solid #ddd" }}>
                <td style={{ padding: "12px" }}>4</td>
                <td style={{ padding: "12px" }}>
                  Mr. Manoj Kumar N.S, Finance Officer
                </td>
                <td style={{ padding: "12px" }}>Member</td>
                <td style={{ padding: "12px" }}>
                  Senior Administrative Officer
                </td>
              </tr>
              <tr style={{ borderBottom: "1px solid #ddd" }}>
                <td style={{ padding: "12px" }}>5</td>
                <td style={{ padding: "12px" }}>
                  Dr. Shiddaiah S. Shirur, COE
                </td>
                <td style={{ padding: "12px" }}>Member</td>
                <td style={{ padding: "12px" }}>
                  Senior Administrative Officer
                </td>
              </tr>
              <tr style={{ borderBottom: "1px solid #ddd" }}>
                <td style={{ padding: "12px" }}>6</td>
                <td style={{ padding: "12px" }}>
                  Dr. Mohd Afzal Azam, Professor of Pharmacy
                </td>
                <td style={{ padding: "12px" }}>Member</td>
                <td style={{ padding: "12px" }}>Senior Faculty Member</td>
              </tr>
              <tr style={{ borderBottom: "1px solid #ddd" }}>
                <td style={{ padding: "12px" }}>7</td>
                <td style={{ padding: "12px" }}>
                  Dr. R.S. Jagadish, Prof & Dean Student Welfare
                </td>
                <td style={{ padding: "12px" }}>IQAC-Coordinator</td>
                <td style={{ padding: "12px" }}>Senior Faculty Member</td>
              </tr>
              <tr style={{ borderBottom: "1px solid #ddd" }}>
                <td style={{ padding: "12px" }}>8</td>
                <td style={{ padding: "12px" }}>
                  Mr. Sandeep Aggarwal, Director, Emerson India Limited, Noida
                </td>
                <td style={{ padding: "12px" }}>Member</td>
                <td style={{ padding: "12px" }}>Nominee from Employer</td>
              </tr>
              <tr style={{ borderBottom: "1px solid #ddd" }}>
                <td style={{ padding: "12px" }}>9</td>
                <td style={{ padding: "12px" }}>
                  Mr. C.B. Mishra, Chief Technical Officer, Samsung Heavy
                  Engineering, Noida
                </td>
                <td style={{ padding: "12px" }}>Member</td>
                <td style={{ padding: "12px" }}>Nominee from Employer</td>
              </tr>
              <tr style={{ borderBottom: "1px solid #ddd" }}>
                <td style={{ padding: "12px" }}>10</td>
                <td style={{ padding: "12px" }}>
                  Mr. Ankit Gupta, Noida Electronics, Noida, Uttar Pradesh
                </td>
                <td style={{ padding: "12px" }}>Member</td>
                <td style={{ padding: "12px" }}>Nominee from Industrialist</td>
              </tr>
              <tr style={{ borderBottom: "1px solid #ddd" }}>
                <td style={{ padding: "12px" }}>11</td>
                <td style={{ padding: "12px" }}>
                  Mr. Gaurav Piplani, Marketing Manager, Excel Technologies
                </td>
                <td style={{ padding: "12px" }}>Member</td>
                <td style={{ padding: "12px" }}>Nominee from Alumni</td>
              </tr>
              <tr style={{ borderBottom: "1px solid #ddd" }}>
                <td style={{ padding: "12px" }}>12</td>
                <td style={{ padding: "12px" }}>
                  Mr. Rahul Mishra, Zonal Manager, Torrent Pharmaceuticals
                </td>
                <td style={{ padding: "12px" }}>Member</td>
                <td style={{ padding: "12px" }}>Nominee from Stakeholder</td>
              </tr>
              <tr style={{ borderBottom: "1px solid #ddd" }}>
                <td style={{ padding: "12px" }}>13</td>
                <td style={{ padding: "12px" }}>
                  Dr. Dhiraj Pandey, Asso. Prof & HoD, CSE
                </td>
                <td style={{ padding: "12px" }}>Member</td>
                <td style={{ padding: "12px" }}>Senior Faculty Member</td>
              </tr>
              <tr style={{ borderBottom: "1px solid #ddd" }}>
                <td style={{ padding: "12px" }}>14</td>
                <td style={{ padding: "12px" }}>
                  Dr. Vedpal, Asst. Prof, Pharmacy
                </td>
                <td style={{ padding: "12px" }}>Member</td>
                <td style={{ padding: "12px" }}>Senior Faculty Member</td>
              </tr>
              <tr style={{ borderBottom: "1px solid #ddd" }}>
                <td style={{ padding: "12px" }}>15</td>
                <td style={{ padding: "12px" }}>
                  Dr. Anandita, Asst. Prof, Pharmacy
                </td>
                <td style={{ padding: "12px" }}>Member</td>
                <td style={{ padding: "12px" }}>Faculty Member</td>
              </tr>
              <tr style={{ borderBottom: "1px solid #ddd" }}>
                <td style={{ padding: "12px" }}>16</td>
                <td style={{ padding: "12px" }}>
                  Dr. Jaspreet Kaur, Associate Prof, Dept. of CSE
                </td>
                <td style={{ padding: "12px" }}>Member</td>
                <td style={{ padding: "12px" }}>Senior Faculty Member</td>
              </tr>
              <tr style={{ borderBottom: "1px solid #ddd" }}>
                <td style={{ padding: "12px" }}>17</td>
                <td style={{ padding: "12px" }}>
                  Dr. Vinita Khemchandani, Asso. Prof, Dept of Mathematics
                </td>
                <td style={{ padding: "12px" }}>Member</td>
                <td style={{ padding: "12px" }}>Faculty Member</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      {/* Academic Audit Committee Section */}
      <section style={{ marginBottom: "40px" }}>
        <h2>Academic Audit Committee (AAC) Composition</h2>
        <p>
          As per <strong>JSSUNI/REG/CIRCULAR/2024/008</strong> dated 24-10-2024
        </p>
        <div style={{ overflowX: "auto" }}>
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              marginTop: "20px",
            }}
          >
            <thead>
              <tr style={{ backgroundColor: "#343a40", color: "white" }}>
                <th style={{ padding: "12px", textAlign: "left" }}>Sl.No.</th>
                <th style={{ padding: "12px", textAlign: "left" }}>
                  Name of the Faculty
                </th>
                <th style={{ padding: "12px", textAlign: "left" }}>
                  Designation
                </th>
                <th style={{ padding: "12px", textAlign: "left" }}>
                  Department
                </th>
                <th style={{ padding: "12px", textAlign: "left" }}>Remarks</th>
              </tr>
            </thead>
            <tbody>
              <tr style={{ borderBottom: "1px solid #ddd" }}>
                <td style={{ padding: "12px" }}>1</td>
                <td style={{ padding: "12px" }}>Dr. Jagadish R.S</td>
                <td style={{ padding: "12px" }}>Professor and Dean</td>
                <td style={{ padding: "12px" }}>Chemistry</td>
                <td style={{ padding: "12px" }}>Head</td>
              </tr>
              <tr style={{ borderBottom: "1px solid #ddd" }}>
                <td style={{ padding: "12px" }}>2</td>
                <td style={{ padding: "12px" }}>Dr. Dheeraj Pandey</td>
                <td style={{ padding: "12px" }}>Professor</td>
                <td style={{ padding: "12px" }}>CSE & Allied Branches</td>
                <td style={{ padding: "12px" }}>Member</td>
              </tr>
              <tr style={{ borderBottom: "1px solid #ddd" }}>
                <td style={{ padding: "12px" }}>3</td>
                <td style={{ padding: "12px" }}>Dr. Jaspreet Kaur</td>
                <td style={{ padding: "12px" }}>Associate Professor</td>
                <td style={{ padding: "12px" }}>CSE</td>
                <td style={{ padding: "12px" }}>Member</td>
              </tr>
              <tr style={{ borderBottom: "1px solid #ddd" }}>
                <td style={{ padding: "12px" }}>4</td>
                <td style={{ padding: "12px" }}>Dr. Gayatri Shakya</td>
                <td style={{ padding: "12px" }}>Associate Professor</td>
                <td style={{ padding: "12px" }}>ECE</td>
                <td style={{ padding: "12px" }}>Member</td>
              </tr>
              <tr style={{ borderBottom: "1px solid #ddd" }}>
                <td style={{ padding: "12px" }}>5</td>
                <td style={{ padding: "12px" }}>Dr. Vineetha Khemchandani</td>
                <td style={{ padding: "12px" }}>Asst. Professor</td>
                <td style={{ padding: "12px" }}>Maths</td>
                <td style={{ padding: "12px" }}>Member</td>
              </tr>
              <tr style={{ borderBottom: "1px solid #ddd" }}>
                <td style={{ padding: "12px" }}>6</td>
                <td style={{ padding: "12px" }}>Dr. Nishi Sharma</td>
                <td style={{ padding: "12px" }}>Asst. Professor</td>
                <td style={{ padding: "12px" }}>English</td>
                <td style={{ padding: "12px" }}>Member</td>
              </tr>
              <tr style={{ borderBottom: "1px solid #ddd" }}>
                <td style={{ padding: "12px" }}>7</td>
                <td style={{ padding: "12px" }}>Mr. AN Veerendra Kumar</td>
                <td style={{ padding: "12px" }}>
                  Asst. Professor/Asst Registrar (Academic)
                </td>
                <td style={{ padding: "12px" }}>ME</td>
                <td style={{ padding: "12px" }}>Member</td>
              </tr>
              <tr style={{ borderBottom: "1px solid #ddd" }}>
                <td style={{ padding: "12px" }}>8</td>
                <td style={{ padding: "12px" }}>Dr. Abhay Raizade</td>
                <td style={{ padding: "12px" }}>Asst. Prof & HoD</td>
                <td style={{ padding: "12px" }}>Pharmacy</td>
                <td style={{ padding: "12px" }}>Member</td>
              </tr>
              <tr style={{ borderBottom: "1px solid #ddd" }}>
                <td style={{ padding: "12px" }}>9</td>
                <td style={{ padding: "12px" }}>Ms. Archita Katrlia</td>
                <td style={{ padding: "12px" }}>Asst. Professor</td>
                <td style={{ padding: "12px" }}>Pharmacy</td>
                <td style={{ padding: "12px" }}>Member</td>
              </tr>
              <tr style={{ borderBottom: "1px solid #ddd" }}>
                <td style={{ padding: "12px" }}>10</td>
                <td style={{ padding: "12px" }}>Ms. Marjita Chakma</td>
                <td style={{ padding: "12px" }}>Asst. Professor</td>
                <td style={{ padding: "12px" }}>Pharmacy</td>
                <td style={{ padding: "12px" }}>Member</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      {/* Academic Audit Process Section */}
      <section style={{ marginBottom: "40px" }}>
        <h2>Academic Audit Process</h2>
        <div
          style={{
            backgroundColor: "#f8f9fa",
            padding: "20px",
            borderRadius: "8px",
          }}
        >
          <h3>Past Audit Schedule (11-11-2024 to 13-11-2024)</h3>
          <p>
            <strong>Subject:</strong> Academic Audit
          </p>
          <p>
            For streamlining academic process and for smooth conduction of
            classes, preparation of course files is the first step. Keeping the
            same in mind, Course files have to be monitored and modified (if
            required). In order to shoulder the academic responsibilities and
            achieve the excellence in the sphere of teaching-learning, HoDs are
            requested to kindly inform their faculty members to be ready with
            their course files for interaction with the Team of Dean (SW) and
            Academic coordinator from 11-11-2024 to 13-11-2024.
          </p>
          <h4>Department-wise Schedule</h4>
          <ul>
            <li>
              <strong>11-11-2024:</strong> CSE, CSAIML (9:30 AM), CSE DS, IT
              (10:30 AM)
            </li>
            <li>
              <strong>12-11-2024:</strong> EE, ECE, ME (9:30 AM), First year
              subjects (Physics, Chemistry, Maths, English) (10:30 AM)
            </li>
            <li>
              <strong>13-11-2024:</strong> MCA (10:00 AM), Pharmacy (B.Pharma,
              D.Pharma) (11:00 AM)
            </li>
          </ul>

          <h3>Upcoming Audit Schedule (06-01-2025 to 08-01-2025)</h3>
          <p>
            <strong>Subject:</strong> Academic Audit
          </p>
          <p>
            For streamlining academic process and for smooth conduction of
            classes, preparation of course files is the first step. Keeping the
            same in mind, Course files have to be monitored and modified (if
            required). In order to shoulder the academic responsibilities and
            achieve the excellence in the sphere of teaching-learning, HoDs are
            requested to kindly inform their faculty members to be ready with
            their course files for interaction with the Team of Dean (SW) and
            Academic coordinator from 06-01-2025 to 08-01-2025.
          </p>
          <h4>Department-wise Schedule</h4>
          <ul>
            <li>
              <strong>06-01-2025:</strong> CSE, CSAIML (9:30 AM), CSE DS, IT
              (10:30 AM)
            </li>
            <li>
              <strong>07-01-2025:</strong> EE, ECE, ME (9:30 AM), First year
              subjects (Physics, Chemistry, Maths, English) (10:30 AM)
            </li>
            <li>
              <strong>08-01-2025:</strong> MCA (10:00 AM), Pharmacy (B.Pharma,
              D.Pharma, M.Pharma) (11:00 AM)
            </li>
          </ul>

          <h3>Key Audit Components</h3>
          <ol>
            <li>
              Attendance Registers - Duly signed by HOD and reviews of number of
              classes held, Syllabus coverage, and Attendance analysis of
              students.
            </li>
            <li>
              CIE - Question paper and scheme as per format, Evaluation of Blue
              Books as per scheme. List of students who have not performed well
              in CIE’s.
            </li>
            <li>
              Slow learners – List of slow learners identified, Action initiated
              along with supporting documents from HOD and concerned faculty.
            </li>
            <li>
              Mentor Process – Meeting proceedings and action initiated
              thereafter from HOD and concerned faculty.
            </li>
            <li>Students Feedback analysis and action initiated by HOD.</li>
            <li>Visit to labs and documents verification.</li>
            <li>Calendar of Events.</li>
            <li>Students registration details along with fee paid details.</li>
            <li>Internship/Projects/Activity points details.</li>
          </ol>
          <p>
            HODs are requested to prepare all relevant and verified documents
            and actively participate as members during the review process.
            Faculty members on leave, who have scheduled classes or labs, must
            ensure that all necessary documents are made available with the HOD.
            Failure to submit documents in advance will result in being marked
            as NOT AVAILABLE FOR REVIEW by the AMC.
          </p>
        </div>
      </section>

      {/* Course File Index - Theory */}
      <section style={{ marginBottom: "40px" }}>
        <h2>Course File Index - Theory</h2>
        <div style={{ overflowX: "auto" }}>
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              marginTop: "20px",
            }}
          >
            <thead>
              <tr style={{ backgroundColor: "#343a40", color: "white" }}>
                <th style={{ padding: "12px", textAlign: "left" }}>S.No.</th>
                <th style={{ padding: "12px", textAlign: "left" }}>
                  Contents/Description
                </th>
                <th style={{ padding: "12px", textAlign: "left" }}>Yes</th>
                <th style={{ padding: "12px", textAlign: "left" }}>No</th>
                <th style={{ padding: "12px", textAlign: "left" }}>Remarks</th>
              </tr>
            </thead>
            <tbody>
              {[
                {
                  sno: 1,
                  desc: "Vision, Mission of Institute/Dept. (Course Taught)",
                },
                { sno: 2, desc: "Syllabus, Evaluation scheme" },
                {
                  sno: 3,
                  desc: "COs/CO mapping with justification (Bloom's Taxonomy), Course Mapping with PO and PSOs",
                },
                {
                  sno: 4,
                  desc: "Content beyond syllabus/Gap Analysis (With respect to COs and POs)",
                },
                {
                  sno: 5,
                  desc: "Details of Direct and Indirect Assessment used",
                },
                { sno: 6, desc: "Student List" },
                {
                  sno: 7,
                  desc: "Lesson Plan (Signed by HOD or Module Co-ordinator)",
                },
                { sno: 8, desc: "Time-Table" },
                { sno: 9, desc: "Attendance sheets" },
                {
                  sno: 10,
                  desc: "Record of Unit Tests (Question Paper, attendance sheets, solution, Marks)",
                },
                {
                  sno: 11,
                  desc: "CIE-I analysis/Question paper/Solution (With respect to Bloom's Taxonomy and NBA guidelines)",
                },
                { sno: 12, desc: "Detained Students list" },
                {
                  sno: "12a",
                  desc: "Result analysis of CIE-I (Green, Yellow and Red Band Analysis)",
                },
                { sno: "12b", desc: "List of weak students < 60%" },
                {
                  sno: "12c",
                  desc: "Assignment given to weak student (with COs reflected)",
                },
                {
                  sno: "12d",
                  desc: "Mentoring/Remedial action details and their impact analysis",
                },
                { sno: "12e", desc: "CO attainment of CIE-I" },
                {
                  sno: "12f",
                  desc: "CIE-II analysis/Question paper/Solution (With respect to Bloom's Taxonomy and NBA guidelines)",
                },
                { sno: 13, desc: "Detained Students" },
                {
                  sno: "13a",
                  desc: "Result analysis of CIE-II (Green, Yellow and Red Band Analysis)",
                },
                { sno: "13b", desc: "List of weak students < 60%" },
                {
                  sno: "13c",
                  desc: "Assignment given to weak student (with COs reflected)",
                },
                {
                  sno: "13d",
                  desc: "Mentoring/Remedial action details and their impact analysis",
                },
                { sno: "13e", desc: "CO-attainment of CIE-II" },
                {
                  sno: "13f",
                  desc: "Special Sessional/Question paper/Solution (With respect to Bloom's Taxonomy and NBA guidelines)",
                },
                { sno: 14, desc: "Detained Students" },
                {
                  sno: "14a",
                  desc: "Result analysis of special sessional (Green, Yellow and Red Band Analysis)",
                },
                { sno: "14b", desc: "List of weak students < 60%" },
                {
                  sno: "14c",
                  desc: "Assignment given to weak student (with COs reflected)",
                },
                {
                  sno: "14d",
                  desc: "Mentoring/Remedial action details and their impact analysis",
                },
                { sno: "14e", desc: "CO attainment of special sessional" },
                {
                  sno: "14f",
                  desc: "Mid semester student feedback on course delivery (if taken)",
                },
                { sno: 15, desc: "Consolidated Result analysis (CIE1, CIE2)" },
                { sno: 16, desc: "Activities conducted details" },
                {
                  sno: 17,
                  desc: "Result Analysis of ODD/EVEN External Examination",
                },
                { sno: 18, desc: "Over all CO-PO attainment" },
                { sno: 19, desc: "Conduction of online classes" },
                {
                  sno: 20,
                  desc: "Details of online/Offline classes PDF notes/NPTEL Links/assignments/quizzes/any other T-L sources",
                },
                {
                  sno: 21,
                  desc: "Model Questions Unit wise and Previous year question papers",
                },
                {
                  sno: 22,
                  desc: "Any Other teaching-learning practices/New Pedagogy implemented (Peer, Group learning/PBL/Inquiry based learning/Cooperative learning and their impact analysis)",
                },
                { sno: 23, desc: "Closure report" },
              ].map((item) => (
                <tr key={item.sno} style={{ borderBottom: "1px solid #ddd" }}>
                  <td style={{ padding: "12px" }}>{item.sno}</td>
                  <td style={{ padding: "12px" }}>{item.desc}</td>
                  <td style={{ padding: "12px" }}></td>
                  <td style={{ padding: "12px" }}></td>
                  <td style={{ padding: "12px" }}></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

      {/* Course File Index - Practicals */}
      <section style={{ marginBottom: "40px" }}>
        <h2>Course File Index - Practicals</h2>
        <div style={{ overflowX: "auto" }}>
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              marginTop: "20px",
            }}
          >
            <thead>
              <tr style={{ backgroundColor: "#343a40", color: "white" }}>
                <th style={{ padding: "12px", textAlign: "left" }}>S.No.</th>
                <th style={{ padding: "12px", textAlign: "left" }}>
                  Contents/Description
                </th>
                <th style={{ padding: "12px", textAlign: "left" }}>Yes</th>
                <th style={{ padding: "12px", textAlign: "left" }}>No</th>
                <th style={{ padding: "12px", textAlign: "left" }}>Remarks</th>
              </tr>
            </thead>
            <tbody>
              {[
                {
                  sno: 1,
                  desc: "Vision, Mission of Institute/Dept. (Course Taught)",
                },
                { sno: 2, desc: "Syllabus, Evaluation scheme" },
                {
                  sno: 3,
                  desc: "COs/CO mapping with justification (Bloom's Taxonomy), Course Mapping with PO and PSOs",
                },
                { sno: 4, desc: "List of experiments corresponding COs" },
                { sno: 5, desc: "Gap analysis/Beyond syllabus" },
                {
                  sno: 6,
                  desc: "Mentoring students regarding lab experiments (general Instructions)",
                },
                { sno: 7, desc: "Index" },
                { sno: 8, desc: "Role of Faculty in charge" },
                { sno: 9, desc: "Role of lab assistant/Instructor" },
                {
                  sno: 10,
                  desc: "Procedure to evaluate the performance of students in the labs (rubrics)",
                },
                { sno: 11, desc: "Lab sessional -1" },
                {
                  sno: 12,
                  desc: "Consolidated Result analysis (Lab sessional and OBE assessment)",
                },
                { sno: 13, desc: "Over all CO-PO attainment" },
                { sno: 14, desc: "Instruments available in lab" },
                { sno: 15, desc: "Waste disposal" },
                { sno: 16, desc: "Conduction of online classes" },
                {
                  sno: 17,
                  desc: "Details of online/Offline classes/PDF notes/NPTEL Links/assignments/quizzes/any other T-L sources",
                },
                { sno: 18, desc: "Model viva voce questions experiment wise" },
                {
                  sno: 19,
                  desc: "Any Other teaching-learning practices/New Pedagogy implemented (Peer, Group learning/PBL/Inquiry based learning/Cooperative learning)",
                },
                { sno: 20, desc: "Faculty closure report" },
              ].map((item) => (
                <tr key={item.sno} style={{ borderBottom: "1px solid #ddd" }}>
                  <td style={{ padding: "12px" }}>{item.sno}</td>
                  <td style={{ padding: "12px" }}>{item.desc}</td>
                  <td style={{ padding: "12px" }}></td>
                  <td style={{ padding: "12px" }}></td>
                  <td style={{ padding: "12px" }}></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

      {/* Recent Audit Observations Section */}
      <section style={{ marginBottom: "40px" }}>
        <h2>Recent Audit Observations</h2>
        <div
          style={{
            backgroundColor: "#f8f9fa",
            padding: "20px",
            borderRadius: "8px",
          }}
        >
          <h3>Objective and Methodology</h3>
          <p>
            For keeping the Teaching-Learning process on track considering
            prospective NBA/NAAC visits for major departments, a committee has
            been constituted, headed by Dean (Academics), to monitor Course
            Files. Compiled observations and suggestions are discussed in the
            present report. The aim of depicting the cons (if any) is not to
            pinpoint the existing process. It is to strengthen the process and
            system.
          </p>

          <h3>
            Department: Computer Science and Allied Branches (AIML, DS & IT)
          </h3>
          <p>
            <strong>Members:</strong> Dr. Jagadish R.S, Dr. Gayatri Sakya, Dr.
            Ashima Srivastava, Dr. Nishi Sharma, Dr. Vinita Khemchandani
          </p>
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              marginTop: "20px",
            }}
          >
            <thead>
              <tr style={{ backgroundColor: "#343a40", color: "white" }}>
                <th style={{ padding: "12px", textAlign: "left" }}>
                  Observation Issue
                </th>
                <th style={{ padding: "12px", textAlign: "left" }}>
                  Observation
                </th>
                <th style={{ padding: "12px", textAlign: "left" }}>
                  Remarks/Highlights
                </th>
              </tr>
            </thead>
            <tbody>
              <tr style={{ borderBottom: "1px solid #ddd" }}>
                <td style={{ padding: "12px" }}>Attendance data</td>
                <td style={{ padding: "12px" }}>
                  Mostly faculty members are maintaining attendance data in the
                  register and updating it in the Uniclare app-an app mainly
                  designed for maintaining students data.
                </td>
                <td style={{ padding: "12px" }}>NIL</td>
              </tr>
              <tr style={{ borderBottom: "1px solid #ddd" }}>
                <td style={{ padding: "12px" }}>
                  Teaching Learning Process & Preparation of Course Files
                </td>
                <td style={{ padding: "12px" }}>
                  All the classes are taken properly, faculty members prepare
                  notes and share it on the GCR. They prepare ppts, make proper
                  use of the smart boards in the classes for better
                  understanding of the subjects. Odd semester files are properly
                  maintained. Even sem course files need to be maintained
                  properly. Lab activities and experiments are conducted as per
                  the timeline to be followed.
                </td>
                <td style={{ padding: "12px" }}>NIL</td>
              </tr>
              <tr style={{ borderBottom: "1px solid #ddd" }}>
                <td style={{ padding: "12px" }}>
                  Internal Question Paper Formation
                </td>
                <td style={{ padding: "12px" }}>
                  Question paper formation process is also authentic, Faculty
                  members teaching the subject, prepare separate question
                  papers, question paper is finalized after the moderation.
                </td>
                <td style={{ padding: "12px" }}>NIL</td>
              </tr>
              <tr style={{ borderBottom: "1px solid #ddd" }}>
                <td style={{ padding: "12px" }}>Evaluation Process</td>
                <td style={{ padding: "12px" }}>
                  Answer sheets (blue books) are evaluated and shown to the
                  students as per the dates mentioned in the calendar of
                  activities. Students feedback on the evaluation process also
                  is taken.
                </td>
                <td style={{ padding: "12px" }}>NIL</td>
              </tr>
              <tr style={{ borderBottom: "1px solid #ddd" }}>
                <td style={{ padding: "12px" }}>Academic Activities</td>
                <td style={{ padding: "12px" }}>
                  All academic activities are conducted as per the calendar.
                  Students get benefits from the activities and learn new
                  dimensions.
                </td>
                <td style={{ padding: "12px" }}>NIL</td>
              </tr>
              <tr style={{ borderBottom: "1px solid #ddd" }}>
                <td style={{ padding: "12px" }}>Co-Curricular Activities</td>
                <td style={{ padding: "12px" }}>
                  Students get ample opportunities for participating in
                  co-curricular activities.
                </td>
                <td style={{ padding: "12px" }}></td>
              </tr>
            </tbody>
          </table>
          <p>
            <strong>Note:</strong> CO-PO Attainment couldn’t be calculated as
            the external exam results were awaited, hence the attainment part
            will be calculated and updated in the files.
          </p>

          <h3>Department: Electrical Engineering</h3>
          <p>
            <strong>Members:</strong> Dr. Jagadish R.S, Dr. Gayatri Sakya, Dr.
            A.N Veerendra Kumar, Dr. Ashima Srivastava, Dr. Nishi Sharma, Dr.
            Vinita Khemchandani
          </p>
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              marginTop: "20px",
            }}
          >
            <thead>
              <tr style={{ backgroundColor: "#343a40", color: "white" }}>
                <th style={{ padding: "12px", textAlign: "left" }}>
                  Observation Issue
                </th>
                <th style={{ padding: "12px", textAlign: "left" }}>
                  Observation
                </th>
                <th style={{ padding: "12px", textAlign: "left" }}>
                  Remarks/Highlights
                </th>
              </tr>
            </thead>
            <tbody>
              <tr style={{ borderBottom: "1px solid #ddd" }}>
                <td style={{ padding: "12px" }}>Attendance data</td>
                <td style={{ padding: "12px" }}>
                  Mostly faculty members are maintaining attendance data in the
                  register and updating it in the Uniclare app-an app mainly
                  designed for maintaining students data.
                </td>
                <td style={{ padding: "12px" }}>NIL</td>
              </tr>
              <tr style={{ borderBottom: "1px solid #ddd" }}>
                <td style={{ padding: "12px" }}>
                  Teaching Learning Process & Preparation of Course Files
                </td>
                <td style={{ padding: "12px" }}>
                  All the classes are taken properly, faculty members prepare
                  notes and share it on the GCR. They prepare ppts, make proper
                  use of the smart boards in the classes for better
                  understanding of the subjects. Odd semester files are properly
                  maintained. Even sem course files need to be maintained
                  properly. Lab activities and experiments are conducted as per
                  the timeline to be followed.
                </td>
                <td style={{ padding: "12px" }}>NIL</td>
              </tr>
              <tr style={{ borderBottom: "1px solid #ddd" }}>
                <td style={{ padding: "12px" }}>
                  Internal Question Paper Formation
                </td>
                <td style={{ padding: "12px" }}>
                  Question paper formation process is also authentic, Faculty
                  members teaching the subject, prepare separate question
                  papers, question paper is finalized after the moderation.
                </td>
                <td style={{ padding: "12px" }}>NIL</td>
              </tr>
              <tr style={{ borderBottom: "1px solid #ddd" }}>
                <td style={{ padding: "12px" }}>Evaluation Process</td>
                <td style={{ padding: "12px" }}>
                  Answer sheets (blue books) are evaluated and shown to the
                  students as per the dates mentioned in the calendar of
                  activities. Students feedback on the evaluation process also
                  is taken.
                </td>
                <td style={{ padding: "12px" }}>NIL</td>
              </tr>
              <tr style={{ borderBottom: "1px solid #ddd" }}>
                <td style={{ padding: "12px" }}>Academic Activities</td>
                <td style={{ padding: "12px" }}>
                  All academic activities are conducted as per the calendar.
                  Students get benefits from the activities and learn new
                  dimensions.
                </td>
                <td style={{ padding: "12px" }}>NIL</td>
              </tr>
              <tr style={{ borderBottom: "1px solid #ddd" }}>
                <td style={{ padding: "12px" }}>Co-Curricular Activities</td>
                <td style={{ padding: "12px" }}>
                  Students get ample opportunities for participating in
                  co-curricular activities.
                </td>
                <td style={{ padding: "12px" }}></td>
              </tr>
            </tbody>
          </table>
          <p>
            <strong>Note:</strong> CO-PO Attainment couldn’t be calculated as
            the external exam results were awaited, hence the attainment part
            will be calculated and updated in the files.
          </p>

          <h3>Department: Mechanical Engineering</h3>
          <p>
            <strong>Members:</strong> Dr. Jagadish R.S, Dr. Gayatri Sakya, Dr.
            Ashima Srivastava, Dr. Nishi Sharma, Dr. Vinita Khemchandani
          </p>
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              marginTop: "20px",
            }}
          >
            <thead>
              <tr style={{ backgroundColor: "#343a40", color: "white" }}>
                <th style={{ padding: "12px", textAlign: "left" }}>
                  Observation Issue
                </th>
                <th style={{ padding: "12px", textAlign: "left" }}>
                  Observation
                </th>
                <th style={{ padding: "12px", textAlign: "left" }}>
                  Remarks/Highlights
                </th>
              </tr>
            </thead>
            <tbody>
              <tr style={{ borderBottom: "1px solid #ddd" }}>
                <td style={{ padding: "12px" }}>Attendance data</td>
                <td style={{ padding: "12px" }}>
                  Mostly faculty members are maintaining attendance data in the
                  register and updating it in the Uniclare app-an app mainly
                  designed for maintaining students data.
                </td>
                <td style={{ padding: "12px" }}>NIL</td>
              </tr>
              <tr style={{ borderBottom: "1px solid #ddd" }}>
                <td style={{ padding: "12px" }}>
                  Teaching Learning Process & Preparation of Course Files
                </td>
                <td style={{ padding: "12px" }}>
                  All the classes are taken properly, faculty members prepare
                  notes and share it on the GCR. They prepare ppts, make proper
                  use of the smart boards in the classes for better
                  understanding of the subjects. Odd semester files are properly
                  maintained. Even sem course files need to be maintained
                  properly. Lab activities and experiments are conducted as per
                  the timeline to be followed.
                </td>
                <td style={{ padding: "12px" }}>NIL</td>
              </tr>
              <tr style={{ borderBottom: "1px solid #ddd" }}>
                <td style={{ padding: "12px" }}>
                  Internal Question Paper Formation
                </td>
                <td style={{ padding: "12px" }}>
                  Question paper formation process is also authentic, Faculty
                  members teaching the subject, prepare separate question
                  papers, question paper is finalized after the moderation.
                </td>
                <td style={{ padding: "12px" }}>NIL</td>
              </tr>
              <tr style={{ borderBottom: "1px solid #ddd" }}>
                <td style={{ padding: "12px" }}>Evaluation Process</td>
                <td style={{ padding: "12px" }}>
                  Answer sheets (blue books) are evaluated and shown to the
                  students as per the dates mentioned in the calendar of
                  activities. Students feedback on the evaluation process also
                  is taken.
                </td>
                <td style={{ padding: "12px" }}>NIL</td>
              </tr>
              <tr style={{ borderBottom: "1px solid #ddd" }}>
                <td style={{ padding: "12px" }}>Academic Activities</td>
                <td style={{ padding: "12px" }}>
                  All academic activities are conducted as per the calendar.
                  Students get benefits from the activities and learn new
                  dimensions.
                </td>
                <td style={{ padding: "12px" }}>NIL</td>
              </tr>
              <tr style={{ borderBottom: "1px solid #ddd" }}>
                <td style={{ padding: "12px" }}>Co-Curricular Activities</td>
                <td style={{ padding: "12px" }}>
                  Students get ample opportunities for participating in
                  co-curricular activities.
                </td>
                <td style={{ padding: "12px" }}></td>
              </tr>
            </tbody>
          </table>
          <p>
            <strong>Note:</strong> CO-PO Attainment couldn’t be calculated as
            the external exam results were awaited, hence the attainment part
            will be calculated and updated in the files.
          </p>

          <h3>Department: Electronics and Communication Engineering</h3>
          <p>
            <strong>Members:</strong> Dr. Jagadish R.S, Dr. A.N Veerendra Kumar,
            Dr. Ashima Srivastava, Dr. Nishi Sharma, Dr. Vinita Khemchandani
          </p>
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              marginTop: "20px",
            }}
          >
            <thead>
              <tr style={{ backgroundColor: "#343a40", color: "white" }}>
                <th style={{ padding: "12px", textAlign: "left" }}>
                  Observation Issue
                </th>
                <th style={{ padding: "12px", textAlign: "left" }}>
                  Observation
                </th>
                <th style={{ padding: "12px", textAlign: "left" }}>
                  Remarks/Highlights
                </th>
              </tr>
            </thead>
            <tbody>
              <tr style={{ borderBottom: "1px solid #ddd" }}>
                <td style={{ padding: "12px" }}>Attendance data</td>
                <td style={{ padding: "12px" }}>
                  Mostly faculty members are maintaining attendance data in the
                  register and updating it in the Uniclare app-an app mainly
                  designed for maintaining students data.
                </td>
                <td style={{ padding: "12px" }}>NIL</td>
              </tr>
              <tr style={{ borderBottom: "1px solid #ddd" }}>
                <td style={{ padding: "12px" }}>
                  Teaching Learning Process & Preparation of Course Files
                </td>
                <td style={{ padding: "12px" }}>
                  All the classes are taken properly, faculty members prepare
                  notes and share it on the GCR. They prepare ppts, make proper
                  use of the smart boards in the classes for better
                  understanding of the subjects. Odd semester files are properly
                  maintained. Even sem course files need to be maintained
                  properly. Lab activities and experiments are conducted as per
                  the timeline to be followed.
                </td>
                <td style={{ padding: "12px" }}>
                  In PLA Labs, students are motivated to go for external
                  certification of MAT Lab. In EFTC Lab, students are given
                  exposure to have understanding of IELTS Paper.
                </td>
              </tr>
              <tr style={{ borderBottom: "1px solid #ddd" }}>
                <td style={{ padding: "12px" }}>
                  Internal Question Paper Formation
                </td>
                <td style={{ padding: "12px" }}>
                  Question paper formation process is also authentic, Faculty
                  members teaching the subject, prepare separate question
                  papers, question paper is finalized after the moderation.
                </td>
                <td style={{ padding: "12px" }}>NIL</td>
              </tr>
              <tr style={{ borderBottom: "1px solid #ddd" }}>
                <td style={{ padding: "12px" }}>Evaluation Process</td>
                <td style={{ padding: "12px" }}>
                  Answer sheets (blue books) are evaluated and shown to the
                  students as per the dates mentioned in the calendar of
                  activities. Students feedback on the evaluation process also
                  is taken.
                </td>
                <td style={{ padding: "12px" }}>NIL</td>
              </tr>
              <tr style={{ borderBottom: "1px solid #ddd" }}>
                <td style={{ padding: "12px" }}>Academic Activities</td>
                <td style={{ padding: "12px" }}>
                  All academic activities are conducted as per the calendar.
                  Students get benefits from the activities and learn new
                  dimensions.
                </td>
                <td style={{ padding: "12px" }}>NIL</td>
              </tr>
              <tr style={{ borderBottom: "1px solid #ddd" }}>
                <td style={{ padding: "12px" }}>Co-Curricular Activities</td>
                <td style={{ padding: "12px" }}>
                  Students get ample opportunities for participating in
                  co-curricular activities.
                </td>
                <td style={{ padding: "12px" }}></td>
              </tr>
            </tbody>
          </table>
          <p>
            <strong>Note:</strong> CO-PO Attainment couldn’t be calculated as
            the external exam results were awaited, hence the attainment part
            will be calculated and updated in the files.
          </p>

          <h3>
            Department: Applied Science (Physics, Chemistry, Maths) and
            Humanities
          </h3>
          <p>
            <strong>Members:</strong> Dr. Jagadish R.S, Dr. Gayatri Sakya, Dr.
            A.N Veerendra Kumar, Dr. Jaspreet Kaur
          </p>
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              marginTop: "20px",
            }}
          >
            <thead>
              <tr style={{ backgroundColor: "#343a40", color: "white" }}>
                <th style={{ padding: "12px", textAlign: "left" }}>
                  Observation Issue
                </th>
                <th style={{ padding: "12px", textAlign: "left" }}>
                  Observation
                </th>
                <th style={{ padding: "12px", textAlign: "left" }}>
                  Remarks/Highlights
                </th>
              </tr>
            </thead>
            <tbody>
              <tr style={{ borderBottom: "1px solid #ddd" }}>
                <td style={{ padding: "12px" }}>Attendance data</td>
                <td style={{ padding: "12px" }}>
                  Mostly faculty members are maintaining attendance data in the
                  register and updating it in the Uniclare app-an app mainly
                  designed for maintaining students data.
                </td>
                <td style={{ padding: "12px" }}>NIL</td>
              </tr>
              <tr style={{ borderBottom: "1px solid #ddd" }}>
                <td style={{ padding: "12px" }}>
                  Teaching Learning Process & Preparation of Course Files
                </td>
                <td style={{ padding: "12px" }}>
                  All the classes are taken properly, faculty members prepare
                  notes and share it on the GCR. They prepare ppts, make proper
                  use of the smart boards in the classes for better
                  understanding of the subjects. Odd semester files are properly
                  maintained. Even sem course files need to be maintained
                  properly. Lab activities and experiments are conducted as per
                  the timeline to be followed.
                </td>
                <td style={{ padding: "12px" }}>NIL</td>
              </tr>
              <tr style={{ borderBottom: "1px solid #ddd" }}>
                <td style={{ padding: "12px" }}>
                  Internal Question Paper Formation
                </td>
                <td style={{ padding: "12px" }}>
                  Question paper formation process is also authentic, Faculty
                  members teaching the subject, prepare separate question
                  papers, question paper is finalized after the moderation.
                </td>
                <td style={{ padding: "12px" }}>NIL</td>
              </tr>
              <tr style={{ borderBottom: "1px solid #ddd" }}>
                <td style={{ padding: "12px" }}>Evaluation Process</td>
                <td style={{ padding: "12px" }}>
                  Answer sheets (blue books) are evaluated and shown to the
                  students as per the dates mentioned in the calendar of
                  activities. Students feedback on the evaluation process also
                  is taken.
                </td>
                <td style={{ padding: "12px" }}>NIL</td>
              </tr>
              <tr style={{ borderBottom: "1px solid #ddd" }}>
                <td style={{ padding: "12px" }}>Academic Activities</td>
                <td style={{ padding: "12px" }}>
                  All academic activities are conducted as per the calendar.
                  Students get benefits from the activities and learn new
                  dimensions.
                </td>
                <td style={{ padding: "12px" }}>NIL</td>
              </tr>
              <tr style={{ borderBottom: "1px solid #ddd" }}>
                <td style={{ padding: "12px" }}>Co-Curricular Activities</td>
                <td style={{ padding: "12px" }}>
                  Students get ample opportunities for participating in
                  co-curricular activities.
                </td>
                <td style={{ padding: "12px" }}></td>
              </tr>
            </tbody>
          </table>
          <p>
            <strong>Note:</strong> CO-PO Attainment couldn’t be calculated as
            the external exam results were awaited, hence the attainment part
            will be calculated and updated in the files.
          </p>

          <h3>Common Recommendations</h3>
          <ul>
            <li>Complete pending course files.</li>
            <li>Update CO-PO attainment after external results.</li>
            <li>Maintain even semester files with same rigor.</li>
          </ul>
        </div>
      </section>

      {/* Quality Assurance Section */}
      <section>
        <h2>Quality Assurance Measures</h2>
        <div style={{ display: "flex", flexWrap: "wrap", gap: "20px" }}>
          <div
            style={{
              flex: "1",
              minWidth: "300px",
              padding: "20px",
              backgroundColor: "#e9ecef",
              borderRadius: "8px",
            }}
          >
            <h3>Continuous Improvement</h3>
            <ul>
              <li>Regular feedback mechanisms</li>
              <li>Quality assurance audits</li>
              <li>Self-assessment reports</li>
              <li>
                Internal Quality Assurance Cell (IQAC) for monitoring quality
              </li>
            </ul>
          </div>

          <div
            style={{
              flex: "1",
              minWidth: "300px",
              padding: "20px",
              backgroundColor: "#e9ecef",
              borderRadius: "8px",
            }}
          >
            <h3>Outcome-Based Education</h3>
            <ul>
              <li>Clear learning outcomes</li>
              <li>Continuous assessment</li>
              <li>Academic flexibility</li>
            </ul>
          </div>

          <div
            style={{
              flex: "1",
              minWidth: "300px",
              padding: "20px",
              backgroundColor: "#e9ecef",
              borderRadius: "8px",
            }}
          >
            <h3>Research & Innovation</h3>
            <ul>
              <li>Research centers and labs</li>
              <li>Industry collaborations</li>
              <li>Startup incubation support</li>
              <li>Research funding and grants</li>
            </ul>
          </div>

          <div
            style={{
              flex: "1",
              minWidth: "300px",
              padding: "20px",
              backgroundColor: "#e9ecef",
              borderRadius: "8px",
            }}
          >
            <h3>Community Engagement</h3>
            <ul>
              <li>Industry and community collaboration</li>
              <li>Environmental sustainability initiatives</li>
              <li>Social responsibility programs</li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
}
